import { render, staticRenderFns } from "./ExportPrestage.vue?vue&type=template&id=33a1997b&scoped=true&"
import script from "./ExportPrestage.vue?vue&type=script&lang=js&"
export * from "./ExportPrestage.vue?vue&type=script&lang=js&"
import style0 from "./ExportPrestage.vue?vue&type=style&index=0&id=33a1997b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a1997b",
  null
  
)

export default component.exports